<div class="dashboard-assets-container">
  <ng-template ngFor let-asset [ngForOf]="assets" let-i="index">
    <div class="asset-item">
      <div class="h-auto bg-white cursor-pointer rounded-lg shadow-lg relative" (click)="assetIDToParam(asset._id)">
        <div class="dashboard-asset-container asset-image-box">
          <img *ngIf="asset.imageUrl || asset.previewUrl" class="dashboard-asset-image" [src]="asset.imageUrl || asset.previewUrl | imageLoading | async" alt="{{ asset.name }}" />
          <div *ngIf="!asset.imageUrl && !asset.previewUrl" class="h-full w-full flex justify-center items-center">
            @if (asset.assetType !== 'Powerpoint presentation') {
              <span class="text-sm font-bold text-center" i18n>Preview Not Available</span>
              <mat-icon class="cursor-pointer mr-2 material-icons-outlined">description</mat-icon>&nbsp;<span i18n>Click to preview</span>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
